import { render, staticRenderFns } from "./ReinInfo.vue?vue&type=template&id=6a8d5db6&scoped=true&"
import script from "./ReinInfo.vue?vue&type=script&lang=js&"
export * from "./ReinInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReinInfo.vue?vue&type=style&index=0&id=6a8d5db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d5db6",
  null
  
)

export default component.exports